import _regeneratorRuntime from "@babel/runtime/regenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var Headers = function () {
  function Headers(headers) {
    _classCallCheck(this, Headers);

    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function (value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  _createClass(Headers, [{
    key: "append",
    value: function append(name, value) {
      name = normalizeName(name);
      value = normalizeValue(value);
      var oldValue = this.map[name];
      this.map[name] = oldValue ? "".concat(oldValue, ", ").concat(value) : value;
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      delete this.map[normalizeName(name)];
    }
  }, {
    key: "get",
    value: function get(name) {
      name = normalizeName(name);
      return this.has(name) ? this.map[name] : null;
    }
  }, {
    key: "has",
    value: function has(name) {
      return this.map.hasOwnProperty(normalizeName(name));
    }
  }, {
    key: "set",
    value: function set(name, value) {
      this.map[normalizeName(name)] = normalizeValue(value);
    }
  }, {
    key: "forEach",
    value: function forEach(callback, thisArg) {
      for (var name in this.map) {
        if (this.map.hasOwnProperty(name)) {
          callback.call(thisArg, this.map[name], name, this);
        }
      }
    }
  }, {
    key: "keys",
    value: function keys() {
      var items = [];
      this.forEach(function (value, name) {
        items.push(name);
      });
      return iteratorFor(items);
    }
  }, {
    key: "values",
    value: function values() {
      var items = [];
      this.forEach(function (value) {
        items.push(value);
      });
      return iteratorFor(items);
    }
  }, {
    key: "entries",
    value: function entries() {
      var items = [];
      this.forEach(function (value, name) {
        items.push([name, value]);
      });
      return iteratorFor(items);
    }
  }, {
    key: Symbol.iterator,
    value: _regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.delegateYield(this.entries(), "t0", 1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, value, this);
    })
  }]);

  return Headers;
}();

export { Headers as default };

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name);
  }

  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name');
  }

  return name.toLowerCase();
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value);
  }

  return value;
}

function iteratorFor(items) {
  var iterator = {
    next: function next() {
      var value = items.shift();
      return {
        done: value === undefined,
        value: value
      };
    }
  };

  iterator[Symbol.iterator] = function () {
    return iterator;
  };

  return iterator;
}
//# sourceMappingURL=headers.node.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@loaders.gl/polyfills/dist/esm/fetch-node/headers.node.js
// module id = 507
// module chunks = 0